import { useParams } from 'react-router';
import env from '~/env';
import { useIntl } from '~/helpers/intl';

export function FindDealer({ productName }: { productName: string }) {
  const { t, tReact } = useIntl();
  const { language } = useParams();
  const dealerLink = `${env.APP_BASE_URL}/${language}/company/resellers/`;

  return (
    <div>
      <p className="text-grey-60 text-xs text-center">
        {tReact('components.ProductLayout.buyAtLocalDealer', {
          fallback: 'Buy {productName} at your local dealer: {dealerLink}',
          values: {
            productName: productName,
            dealerLink: (
              <a
                href={dealerLink}
                className="webex-link text-xs underline decoration-current"
                data-testid="find-dealer-link"
              >
                {t('components.ProductLayout.findDealer', {
                  fallback: 'Find a Dealer',
                })}
              </a>
            ),
          },
        })}
      </p>
    </div>
  );
}
